type TagVariant = "success" | "info" | "warning" | "error" | "neutral";

class Type {
	public static PAID = new Type("paid", "Paid", "success");
	public static OPEN = new Type("open", "Open", "info");
	public static PENDING = new Type("pending", "Pending", "info");
	public static PROCESSING = new Type("processing", "Processing", "info");
	public static PAST_DUE = new Type("past_due", "Past Due", "warning");
	public static FAILED = new Type("failed", "Failed", "error");
	public static VOIDED = new Type("voided", "Voided", "neutral");
	public static CLOSED = new Type("closed", "Closed", "neutral");

	private constructor(
		public readonly value: string,
		public readonly label: string,
		public readonly tag: TagVariant,
	) {}

	public static values(): Type[] {
		return [Type.PAID, Type.OPEN, Type.PENDING, Type.PROCESSING, Type.PAST_DUE, Type.FAILED, Type.VOIDED, Type.CLOSED];
	}

	public static getByValue(value?: string) {
		return this.values().find((type) => type.value === value?.toLowerCase());
	}
}

export { Type as BillingInvoiceStatusType };
